module.exports = __webpack_public_path__ + "img/propertylist3.c4dfaef4.png";